import { ManageLocaleKey } from "../../helpers/constants/siteCoreKeys";
import { KeyValueMap } from "../../redux/slices/appState/models";

export const getPlaceHolderKey = (
  commonLabels: KeyValueMap,
  localeKey: string,
) => {
  switch (localeKey) {
    case ManageLocaleKey.french:
      return commonLabels.frenchPlaceholder;
    case ManageLocaleKey.brazilian:
      return commonLabels.brazilPlaceholder;
    case ManageLocaleKey.japaneseName:
      return commonLabels.japanesePlaceholder;
    default:
      return commonLabels.inputPlaceHolder;
  }
};
